export const ADD_MFA_WITH_SMS_OTP_FLOW_ID = 'add-mfa-with-sms-otp';

export enum AddMfaWithSmsOtpScreenNames {
  PHONE_NUMBER = 'User Information - Unverified - Phone Only',
  VERIFY_OTP = 'Verify OTP',
}

export const ADD_MFA_WITH_SMS_OTP_SCREEN_IDS = {
  PHONE_NUMBER: 'SC33AKtpTHbwc5NOeakynBDup93VI',
  VERIFY_OTP: 'SC33AKtq14t7mF7uh5QXY4fStfJYV',
};

export const ADD_MFA_WITH_SMS_OTP_INTERACTION_IDS = {
  SUBMIT_PHONE: 'PB4s0Xy7gp',
  SUBMIT_CODE: 'cgY8dBnKu5',
  USE_DIFFERENT_NUMBER: 'pnOqEGpL1b',
  RESEND: 'resend',
};
